import React, { useState, useContext } from 'react';
import { PropTypes } from 'prop-types';

import Config from '@skin_config';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { depositMethods } from '@app/dev/constants/depositMethods';
import { getAuthData } from '@common/helpers/auth';
import LoaderButton from '@common/components/loaderButton';

import DepositAmountForm from '../../pieces/depositAmountForm';
import DepositIframe from '../../pieces/depositIframe';
import DepositServicePix from './service';

const DepositContentPixSafeway = ({ type }) => {
  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);

  const [amount, setAmount] = useState('');
  const [errorText, setErrorText] = useState('');
  const [forwardUrl, setForwardUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const confirmAmount = async () => {
    const { currency } = getAuthData();
    const { minAmount = 0 } = Config.depositMethods.find((method) => method.type === type);

    if (!+amount) return;

    if (+amount < minAmount) return setErrorText(['Minimum amount should be {1}', `${minAmount} ${currency}`]);

    setLoading(true);

    const response = await DepositServicePix.createOrder(+amount);

    setLoading(false);

    if (response.errorText) setErrorText(response.errorText);
    else setForwardUrl(response.forwardUrl);
  };

  const back = () => {
    setErrorText('');
    setForwardUrl(null);
  };

  return (
    <div className={`popup-content ${forwardUrl ? 'deposit-iframe-wrapper' : 'popup-small'}`}>
      <h3 className="popup-title">{t('Deposit with {1}', depositMethods[type].name)}</h3>

      {forwardUrl ? (
        <>
          <DepositIframe
            name={depositMethods[type].name}
            url={forwardUrl}
          />

          <div className="popup-actions">
            <button type="button" onClick={back} className="popup-cancel-button">{t('Back')}</button>
            <button type="button" onClick={closePopup} className="popup-confirm-button">{t('Done')}</button>
          </div>
        </>
      ) : (
        <>
          <DepositAmountForm
            amount={amount}
            onChange={setAmount}
            errorText={errorText}
          />

          <div className="popup-actions">
            <button type="button" onClick={closePopup} className="popup-cancel-button">{t('Cancel')}</button>

            <LoaderButton
              loading={loading}
              onClick={confirmAmount}
              className="popup-confirm-button"
            >
              {t('Next')}
            </LoaderButton>
          </div>
        </>
      )}
    </div>
  );
};

DepositContentPixSafeway.propTypes = {
  type: PropTypes.string.isRequired,
};

export default DepositContentPixSafeway;
